// extracted by css-extract-rspack-plugin
export default {"CommentActionsIconButton":"CommentActions-module__CommentActionsIconButton__Fsg4J","CommentActionsListItem":"CommentActions-module__CommentActionsListItem__EJc3z"};